import React, { useState, useEffect } from 'react';
import { Modal, Input, Divider } from 'antd';

import requestAPI from 'helpers/requestAPI';
import { toastError, toastSuccess } from 'utils/toastr';

import './nameserver.scss';

const NSModal = ({ changeVisible, visible, updateNS, editMode, hostName }) => {
	const [ hostUrl, setHostUrl ] = useState('');
	const [ ns, setNs ] = useState({
		ns1: '',
		ns2: '',
		ns3: '',
		ns4: ''
	});
	const [ nsId, setNsId ] = useState([]);

	useEffect(
		() => {
			if (editMode) {
				const params = {
					routeParams: {
						route: 'name_servers_template'
					}
				};

				requestAPI(params)
					.then((resp) => {
						const nsData = resp.data.data.filter((elem) => {
							return elem.host_url === hostName;
						});

						setHostUrl(nsData[0].host_url);

						const nsListName = {};
						const nsListId = [];

						nsData.forEach((element, i) => {
							nsListName[`ns${i + 1}`] = element.ns;
							nsListId.push(element.id);
						});

						setNs((n) => {
							return { ...n, ...nsListName };
						});
						setNsId(nsListId);
					})
					.catch((err) => toastError(err));
			} else {
				setHostUrl('');
				setNs({
					ns1: '',
					ns2: '',
					ns3: '',
					ns4: ''
				});
			}
		},
		[ editMode, hostName ]
	);

	const handleSubmit = () => {
		const nsList = [];
		for (let key in ns) {
			if (ns[key]) {
				nsList.push(ns[key]);
			}
		}

		if (!hostUrl) {
			toastError('Enter host url!');
			return;
		}

		if (!nsList.length) {
			toastError('Enter at least one ns!');
			return;
		}

		if (editMode) {
			nsId.forEach((elem, i) => {
				const params = {
					routeParams: {
						route: 'name_servers_template',
						id: elem
					},
					method: 'PUT',
					data: {
						ns: ns[`ns${i + 1}`],
						host_url: hostUrl
					}
				};

				requestAPI(params)
					.then(() => {
						if (nsId.length === i + 1) {
							updateNS();
							toastSuccess('Edited!');
							changeVisible();
						}
					})
					.catch((err) => toastError(err));
			});
		} else {
			const params = {
				routeParams: {
					route: 'name_servers_template'
				},
				method: 'POST',
				data: {
					host_url: hostUrl,
					ns_list: nsList
				}
			};

			requestAPI(params).then(() => {
				updateNS();
				toastSuccess('Added!');
				changeVisible();
			});
		}
	};

	const checkDisbled = (ns) => {
		if (!editMode) return false;
		return !ns;
	};

	const handleChangeNs = (e) => {
		setNs({ ...ns, [e.target.name]: e.target.value })
	}

	const handleChangeHostUrl = (e) => {
		setHostUrl(e.target.value);
	}

	return (
		<Modal
			className="nameserver-modal"
			title={editMode ? 'Edit NameServer' : 'Add custom NameServer'}
			visible={visible}
			onOk={handleSubmit}
			onCancel={changeVisible}
		>
			<Input
				placeholder="Enter Host Url"
				value={hostUrl}
				onChange={handleChangeHostUrl}
			/>

			<Divider />
			<div className="nameserver-modal__ns-container">
				<Input
					placeholder="Enter ns1"
					className="nameserver-modal__ns-input"
					name='ns1'
					value={ns.ns1}
					onChange={handleChangeNs}
				/>
				<Input
					placeholder="Enter ns2"
					className="nameserver-modal__ns-input"
					name='ns2'
					value={ns.ns2}
					disabled={checkDisbled(ns.ns2)}
					onChange={handleChangeNs}
				/>
				<Input
					placeholder="Enter ns3"
					className="nameserver-modal__ns-input"
					name='ns3'
					value={ns.ns3}
					disabled={checkDisbled(ns.ns3)}
					onChange={handleChangeNs}
				/>
				<Input
					placeholder="Enter ns4"
					className="nameserver-modal__ns-input"
					name='ns4'
					value={ns.ns4}
					disabled={checkDisbled(ns.ns4)}
					onChange={handleChangeNs}
				/>
			</div>
		</Modal>
	);
};

export default NSModal;
